import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import Spinner from "../util/Spinner";
import { fetchTVShowList } from "../slice/tvShowListsSlice";
import { fetchTVShowListItems } from "../slice/tvShowListItemsSlice";

const TVShowListByActor = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  // params from url
  const { listsid } = useParams();
  const actor = location.state?.actor;
  const [shouldRefresh, setShouldRefresh] = useState(true);

  // tv show list
  const { tvShowList, isLoading } = useSelector((state) => {
    return state?.tvShowLists;
  });

  // tv show list items
  const { content, page, totalPages, totalElements, isLoadingItems } =
    useSelector((state) => {
      console.log("items: ", state?.tvShowListItems);
      return state?.tvShowListItems;
    });

  // fetch the tv show list
  useEffect(() => {
    if (listsid) {
      console.log("calling fetch tv show list with sid ", listsid);
      dispatch(fetchTVShowList(listsid));
    }
  }, [dispatch, listsid, page, shouldRefresh]);

  // fetch tv show list items
  useEffect(() => {
    if (listsid && actor) {
      console.log(
        "calling fetch tv shows for list " + listsid + " with actor",
        actor?.sid
      );
      dispatch(fetchTVShowListItems({ sid: listsid, actor: actor?.sid }));
    }
  }, [dispatch, listsid, page, actor, shouldRefresh]);

  const listItems = () => {
    return content?.map((item) => {
      return (
        <li key={item?.sid}>
          <Link
            to={`/tvshows/${listsid}/${item?.sid}`}
            className="text-teal-700 hover:underline"
          >
            {item?.tvShow?.title}
          </Link>
        </li>
      );
    });
  };

  return (
    <div className="max-w-2xl mx-auto p-4 md:p-6">
      {isLoading || isLoadingItems ? (
        <Spinner />
      ) : (
        <dl className="card p-4 md:p-6 divide-y divide-stone-200">
          <div className="py-3 first:pt-0">
            <dt className="text-sm font-medium text-stone-500">List</dt>
            <dd className="mt-1 text-stone-800">
              <Link
                to={`/tvshows/${listsid}`}
                className="text-teal-700 hover:underline"
              >
                {tvShowList?.name}
              </Link>
            </dd>
          </div>
          <div className="py-3">
            <dt className="text-sm font-medium text-stone-500">Actor</dt>
            <dd className="mt-1 text-stone-800">{actor?.name}</dd>
          </div>
          <div className="py-3 last:pb-0">
            <dt className="text-sm font-medium text-stone-500">Shows</dt>
            <dd className="mt-1">
              <ul className="list-disc pl-5 space-y-1 text-stone-800">
                {listItems()}
              </ul>
            </dd>
          </div>
        </dl>
      )}
    </div>
  );
};

export default TVShowListByActor;
